import { render, staticRenderFns } from "./StudentVerification.vue?vue&type=template&id=d1bf01a2&scoped=true&lang=pug"
import script from "./StudentVerification.vue?vue&type=script&lang=js"
export * from "./StudentVerification.vue?vue&type=script&lang=js"
import style0 from "./StudentVerification.vue?vue&type=style&index=0&id=d1bf01a2&prod&scoped=true&lang=css"
import style1 from "./StudentVerification.vue?vue&type=style&index=1&id=d1bf01a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bf01a2",
  null
  
)

export default component.exports